import classNames from 'classnames';
import React from 'react';
import { IconButtonProps } from '../../types/components/button';
import './Button.css';
import { BsCloudDownload, BsCopy, BsFillInfoCircleFill, BsXLg } from 'react-icons/bs';
import { BiSearch } from "react-icons/bi";

const IconButton: React.FC<IconButtonProps> = ({ onClick, small, icon, backgroundColor, color, iconType, tooltip, showBadge, selected, disabled, e2eTestId }) => {

    const renderIcon = () => {
        if (typeof icon === 'string') {
          switch (icon) {
            case 'close':
              return <BsXLg />;
            case 'copy':
              return <BsCopy />;
            case 'download':
              return <BsCloudDownload />;
            case 'infomation':
              return <BsFillInfoCircleFill />;
            case 'search':
              return <BiSearch />;
            default:
              return null;
          }
        }
        return icon;
    };

    const onClickIconBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      onClick(e);
    };

    return (
        <button 
          onClick={onClickIconBtn}
          className={
            classNames(
                'icon-button',
                { 
                  'small': small, 
                  'medium': !small, 
                  [color??'primary' as string]: color,
                  [backgroundColor??'white' as string]: backgroundColor,
                  'bg-square': iconType === 'square',
                  'bg-circle': iconType === 'circle',
                  'selected': selected,
                  'disabled': disabled
                }
            )
          }
          disabled={disabled}
          title={tooltip}
          data-e2e-test-id={e2eTestId}
        >
          { showBadge && <div className='icon-button-badge' /> }
          { renderIcon() }
        </button>
    );
};

export default IconButton;
